import type { SVGProps } from 'react';

interface LogoPiece6IconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const LogoPiece6Icon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & LogoPiece6IconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 113 111"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g fill="#44C761" fillOpacity={0.25} opacity={0.3}>
      <path d="M76.409 20.68c22.287 17.641 36.593 44.97 36.593 75.662a98 98 0 0 1-1.939 19.378c-14.419 10.256-33.619 20.889-40.79 23.722-10.655 4.193-10.448.17-9.77-11.842.056-1.171.132-2.437.188-3.778.282-6.119.433-13.787.377-24.798 1.054-15.487.696-23.401 2.127-28.935 1.468-5.61 3.35-15.733 7.19-28.765 2.673-9.028 5.064-17.15 6.024-20.643M67.149 14.184c-.452.378-.923.775-1.431 1.171-9.016 7.177-37.61 27.14-42.805 27.14s-13.007-1.87-20.16-18.622C.382 18.34-3.25 11.578-6.847 4.892c-.3-.548-.602-1.115-.903-1.662A96 96 0 0 1 16.965 0c18.39 0 35.558 5.175 50.146 14.165zM-69.36 54.205C-58.855 32.561-40.502 15.468-18.027 6.63c2.71 7.895 6.42 14.279 9.732 19.963 3.294 5.666 6.193 10.653 7.341 15.79C1.36 52.77-21.887 65.273-27.534 66.822c-2.672.736-6.023-.888-10.522-3.079-4.988-2.417-11.407-5.534-19.896-6.875-3.407-.547-7.323-1.492-11.389-2.682zM51.864 115.36c1.337 15.11 2.523 28.425-8.226 31.466-10.898 3.078-27.237 2.38-36.762 0-1.148-.284-2.485-.605-3.934-.963-10.654-2.569-28.066-6.743-29.082-11.673-2.39-11.596-.678-25.252 1.355-38.888 2.052-13.655 2.73-16.715 5.948-18.774C-17.18 75.49-11.853 69.9-6.3 64.101-.973 58.529 4.542 52.75 7.215 50.559c3.106-2.55 11.407 1.813 19.915 6.29l17.525 7.403c5.722 2.418 7.266 18.66 6.983 34.223-.113 6.119-.207 11.937.17 16.262l.056.604zM59.352 55.94c2.485-6.403 12.386-32.807 6.363-31.013-6.005 1.776-42.41 25.1-34.429 27.764 1.412.472 10.391 3.588 11.953 4.174 7.266 2.72 14.062 4.363 16.113-.907z" />
    </g>
  </svg>
);
